/** @jsx jsx */
import { Flex, Text, jsx } from 'theme-ui'

export const DisciplineBoxes = ({ disciplines }: { disciplines: string[] }) => (
  <Flex
    sx={{
      mt: [0, 3],
      flexDirection: ['column', 'row'],
    }}
  >
    <Text
      sx={{ fontFamily: 'Futura Medium', fontSize: [4], py: [0, 1], mr: [1] }}
    >
      Discipline:
    </Text>
    <Flex
      sx={{
        flexWrap: 'wrap',
      }}
    >
      {disciplines?.map((discipline: string, index) => (
        <Text
          key={index}
          sx={{
            fontFamily: 'Futura Book Regular',
            px: [2],
            py: [1],
            mx: [1, 2],
            my: [1],
            color: '#848484',
            border: '1px solid #848484',
            borderRadius: '5px',
          }}
        >
          {discipline}
        </Text>
      ))}
    </Flex>
  </Flex>
)
